export default __webpack_public_path__ + "static/media/produtividade.2fa4ed65.svg";